import Uiconstants from '../../lib/UIconstants';
import DoubleChanceController from '../../controllers/double_chance/DoubleChanceController';
import { COMPONENTS } from '../../lib/constants';
import { isDesktop } from 'react-device-detect';

export const DoubleChanceWidget = {
	name: COMPONENTS.DOUBLE_CHANCE_WIDGET,
	position: {
		x: 1410,
		y: 245
	},
	controllers: [
		{
			Controller: DoubleChanceController,
			name: 'DoubleChanceController',
			config: {
				item: Uiconstants.FTR_DOUBLE_CHANCE,
				holder: 'holder'
			}
		}
	],
	components: [
		{
			name: 'holder',
			type: 'Sprite',
			position: { x: 0, y: 0 },
			components: [
				{
					name: 'double_wrapper',
					type: 'SimpleButton',
					components: [
						{
							name: 'bg',
							type: 'MouseOverSprite',
							img: 'double_chance_widget_bg',
							imgHover: 'double_chance_widget_bg_hovered',
							components: [
								{
									name: 'double_chance_border',
									type: 'Sprite',
									img: 'double_chance_border',
									position: { x: -2, y: -4 }
								},
								isDesktop && {
									name: 'fg',
									type: 'AnimatedSprite',
									position: { x: 190, y: -70 },
									animation: {
										pattern: 'mciddle_000$.png',
										start: 0,
										end: 51,
										speed: 0.5,
										precision: 2,
										loop: true,
										scale: {
											x: 0.86,
											y: 0.86
										}
									}
								},
								{
									name: Uiconstants.FTR_DOUBLE_CHANCE,
									type: 'SwitchButton',
									position: { x: 28, y: 134 },
									bgimg: 'switcher_btn_on',
									bg: 'switcher_back_on',
									fgimg: 'switcher_btn_off',
									fg: 'switcher_back_on',
									bgText: 'DOUBLE_CHANCE_SWITCHER_ON',
									fgText: 'DOUBLE_CHANCE_SWITCHER_OFF'
								}
							]
						},
						{
							name: 'DOUBLE_CHANCE_VALUE',
							type: 'Text',
							position: { x: 27, y: 23 },
							text: 'DOUBLE_CHANCE_VALUE'
						},
						{
							name: 'DOUBLE_CHANCE_CURRENCY',
							type: 'Text',
							position: { x: 27, y: 42 },
							text: 'DOUBLE_CHANCE_CURRENCY'
						},
						{
							name: 'DOUBLE_CHANCE_TITLE',
							type: 'Text',
							position: { x: 27, y: 73 },
							text: 'DOUBLE_CHANCE_TITLE'
						},
						{
							name: 'DOUBLE_CHANCE_SUBTITLE',
							type: 'Text',
							position: { x: 88, y: 85.5 },
							text: 'DOUBLE_CHANCE_SUBTITLE'
						}
					]
				}
			]
		}
	]
};
